import React from "react"
import { Helmet } from "react-helmet"

import Layout from "../components/layout"
import TextBanner from "../components/text_banner"

function OurJourney() {
  return (
    <Layout>
      <Helmet>
        <title>InTouch Counselling Services - Our Journey</title>
      </Helmet>

      <TextBanner
        quote="“The most powerful relationship you will ever have is the relationship with yourself.” – Diane Von Furstenberg"
      ></TextBanner>

      <section id="wrapper">
        <section id="one" className="wrapper spotlight style1 my-journey">
          <div className="inner">
            <div className="about-content">
              <h2 className="my-practice-caption">
                <div className="icon"></div>
                Our Journey
              </h2>
              <div className="quote">
                “DREAM as if you’ll live forever, Live as if you’ll die TODAY”
                <span>James Dean</span>
              </div>
              <p>
                Awareness and willingness make space for curiosity into the
                exploration of our deeper selves. In turn, they become
                foundational to the journey of self-discovery in therapy. My aim
                and role in the therapeutic process is to work with you to call
                forth you’re in itself awareness and understanding of behaviors
                beliefs and emotions in any area of your life that has become a
                hinderance and are no longer adequate or useful to your present
                experience. Awareness of unconscious patterns and beliefs
                repressed emotions and unresolved trauma, is that affect your
                day-to-day relationships, career and ultimately our happiness
                are gradually brought out of the unconscious into the light of
                day to be acknowledged transformed an integrated into our
                conscious self. This is important for your own path of
                self-awareness! Willingness to embrace all aspects of oneself is
                essential and creating the impetus for change. It is another
                word for open. It is the power to say yes to yourself, and where
                unconscious blocks can now be illuminated and transformed,
                making space for a fuller and more meaningful life a life with
                purpose. We naturally become more open to self-acceptance and
                start to develop self-trust, leading to self-empowerment which
                is the anecdote to being a victim to life’s circumstances. Life
                is given room to be lived authentically in the present rather
                from the wounds of the past and allows for unfolding in the new
                of daily life.
              </p>
            </div>
          </div>
        </section>

        <section id="two" className="wrapper alt spotlight style2">
          <div className="inner">
            <div className="about-content">
              <h2>Thoughts to consider on your therapeutic journey</h2>
              <div className="number-item">
                <span className="number">1</span>
                <p>Are you willing to walk the path towards your well-being?</p>
              </div>
              <div className="number-item">
                <span className="number">2</span>
                <p>
                  What ideas and beliefs about yourself and about life are
                  behind the choices you’ve made?
                </p>
              </div>
              <div className="number-item">
                <span className="number">3</span>
                <p>
                  Who are you now and are you willing to walk towards a more
                  authentic self?
                </p>
              </div>
              <div className="number-item">
                <span className="number">4</span>
                <p> What fears might prevent you from getting there?</p>
              </div>
              <div className="number-item">
                <span className="number">5</span>
                <p>
                  Are the ideas of who you are your own, or have they been
                  imposed upon you by others?
                </p>
              </div>
              <div className="number-item">
                <span className="number">6</span>
                <p>Without the limitations who would you be?</p>
              </div>
              <div className="number-item">
                <span className="number">7</span>
                <p>
                  Keep in mind just because you believe it and it was said to
                  you it doesn’t mean it was true?
                </p>
              </div>
              <br /> <br />
            </div>
          </div>
        </section>
      </section>
    </Layout>
  )
}

export default OurJourney
